let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("j06N4"), load("ffEVr"), load("Wowvf"), load("hhss7"), load("lwfE5")]).then(() => parcelRequire('MkVVm'));